<template>
<div class='vx-row w-full mt-4'>
    <div class="vx-col md:w-1/2 w-full p-3">
        <vs-input class="w-full" size="default" placeholder="Nombre del tipo de juego" v-model="datos.nombre" />
    </div>
    <div class="vx-col md:w-1/2 w-full p-3">
        <vs-input class="w-full" size="default" placeholder="Descripción del tipo de juego" v-model="datos.descripcion" />
    </div>
    <div class="vx-col w-full p-3">
        <vs-radio color="success" class="p-3" v-model="datos.estado" vs-name="radiosEstado" vs-value="1">Activo</vs-radio>
        <vs-radio class="p-3" v-model="datos.estado" vs-name="radiosEstado" vs-value="0">Inactivo</vs-radio>
    </div>
    <div class="vx-col md:w-1/2 sm:w-1/2 lg:w-1/2 p-3">
        <vs-button :color="propiedades.btn_color" @click="f_agregar_editar()"> {{ propiedades.btn_texto }} </vs-button>
    </div>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
export default {
    mixins: [GeneralMixin],
    name: 'TiposGames',
    props: {
        tipoAccion: {
            type: Number
        },
        datosEditar: {
            type: Object
        }
    },
    components: {},
    data() {
        return {
            datos: {},
            propiedades: {
                btn_color: '',
                btn_texto: '',
            },
            arrayTiposGames: [],
            mensaje: '',
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            console.log('tipos', me.tipoAccion)
            me.propiedades.btn_color = 'primary';
            me.propiedades.btn_texto = 'Guardar';
            me.datos = {
                id: '',
                nombre: '',
                descripcion: '',
                estado: 0,
            };
            me.mensaje = 'Datos registrados'
            if (me.tipoAccion === 1) {
                me.datos = me.datosEditar
                console.log('editar', me.datos)
                me.mensaje = 'Datos editados correctamente'
            }
        },
        f_agregar_editar() {
            let me = this;
            console.log(me.tipoAccion)
            if (me.datos.nombre == '') {
                me.f_notificaciones("Ingresa el nombre del tipo de juego", "danger");
                return;
            }
            if (me.datos.descripcion == '') {
                me.f_notificaciones("Ingresa una breve descripción del tipo de juego", "danger");
                return;
            }
            me.$vs.loading();
            me.$http.post(this.$server_url + 'tiposGames', me.datos)
                .then(function (response) {
                    me.arrayTiposGames = response.data;
                    me.$emit('changeData', me.arrayTiposGames);
                    me.f_notificaciones(me.mensaje);
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se obtuvo datos desde la DB", "danger");
                })
        }
    }
};
</script>
